import { render, staticRenderFns } from "./DialogEditInitial.vue?vue&type=template&id=226f9a37"
import script from "./DialogEditInitial.vue?vue&type=script&lang=js"
export * from "./DialogEditInitial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports